import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=52dbb371&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=52dbb371&lang=scss"
import style1 from "./collect.vue?vue&type=style&index=1&id=52dbb371&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dbb371",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52dbb371')) {
      api.createRecord('52dbb371', component.options)
    } else {
      api.reload('52dbb371', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=52dbb371&scoped=true", function () {
      api.rerender('52dbb371', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/data-query/components/collect.vue"
export default component.exports